import React from "react";

import "../styles/Project.css";

export default function Project(props) {
  const { id, title, overview, link } = props.project;
  return (
    <div className="project-tile" key={id}>
      <div className="project-title">{title}</div>
      <div className="project-overview">{overview}</div>
      <a href={link} className="link" target="_blank" rel="noopener noreferrer">
        Link to Code
      </a>
    </div>
  );
}
